<script setup lang="ts">
import PdsIcon from '@/components/pds/PdsIcon.vue';

defineProps<{ label: string }>();
const emit = defineEmits<{ previous: []; next: [] }>();
</script>

<template>
  <div
    class="bg-carte flex h-12 items-center gap-1 rounded-full pr-1 pl-1 text-[16px] font-semibold"
  >
    <button
      type="button"
      aria-label="Jour précédent"
      class="text-encre flex size-10 shrink-0 cursor-pointer items-center justify-center"
      @click="emit('previous')"
    >
      <PdsIcon name="chevron-left" :size="20" />
    </button>
    <span class="px-2 whitespace-nowrap">{{ label }}</span>
    <button
      type="button"
      aria-label="Jour suivant"
      class="text-encre-douce flex size-10 shrink-0 cursor-pointer items-center justify-center"
      @click="emit('next')"
    >
      <PdsIcon name="chevron-right" :size="20" />
    </button>
  </div>
</template>
